import { Check, Circle, Undo2 } from "lucide-react";
import { fmtDate } from "@/lib/api";

function steps(m) {
  const list = [
    { key: "uploaded", label: "Uploaded", at: m.created_at },
    { key: "sent", label: "Paid & sent", at: m.sent_at },
    { key: "delivered", label: "Delivered (recipient notified)", at: m.notified_at },
  ];
  if (m.reminder_7_at) list.push({ key: "r7", label: "Reminder · day 7", at: m.reminder_7_at });
  if (m.reminder_12_at) list.push({ key: "r12", label: "Reminder · day 12", at: m.reminder_12_at });
  if (m.status === "returned") {
    list.push({ key: "returned", label: "Returned to sender", at: m.returned_at, returned: true });
  } else {
    list.push({ key: "claimed", label: "Claimed (identity + OTP confirmed)", at: m.claimed_at });
    list.push({ key: "opened", label: "Opened", at: m.opened_at });
  }
  return list;
}

export const TrackingTimeline = ({ mail }) => (
  <ol data-testid="tracking-timeline" className="relative">
    {steps(mail).map((s, i, arr) => {
      const done = Boolean(s.at);
      return (
        <li key={s.key} data-testid={`timeline-step-${s.key}`} className="relative pl-10 pb-6 last:pb-0">
          {i < arr.length - 1 && <span className={`absolute left-[13px] top-7 bottom-0 w-px ${done ? "bg-emerald-500" : "bg-slate-200 dark:bg-slate-800"}`} />}
          <span className={`absolute left-0 top-0.5 h-7 w-7 rounded-full inline-flex items-center justify-center border ${
            s.returned && done ? "bg-red-600 border-red-600 text-white" : done ? "bg-emerald-600 border-emerald-600 text-white" : "bg-white dark:bg-slate-900 border-slate-300 dark:border-slate-700 text-slate-300"}`}>
            {s.returned ? <Undo2 size={13} /> : done ? <Check size={14} /> : <Circle size={8} />}
          </span>
          <p className={`text-sm font-medium ${done ? "" : "text-slate-400"}`}>{s.label}</p>
          <p className="text-xs font-mono text-slate-500 mt-0.5">{done ? fmtDate(s.at) : "Pending"}</p>
        </li>
      );
    })}
  </ol>
);
